<template>
  <div>
    <h1 v-if="thread == null">Thread "{{$route.params.id}}" not found.</h1>
    <div v-if="thread != null">

      <Thread 
        :thread="thread"
        show-all-tweets="true"
      />

      <template v-if="thread.conversation.hasFailed">
        <!--<template v-if="thread.conversation.conversation.length === 0">-->
          <div class="page-container" style="min-height: 0px; max-width: 1000px;">

            <div style="display: flex; justify-content: center;">
              <div class= "register-container" style="display: flex; flex-direction: column; justify-content: center; margin-top: 2rem; margin-bottom: 2rem;">
                <div class="page-title" style="text-align: center;">💡 Twitter API only allows to fetch a certain number of tweets from the same account</div>
                <button  @click="goTwitter" class="primary-button twitter-button">Read on Twitter</button>
              </div>
            </div>

          </div>
        <!--</template>-->
      </template>

      <div class="page-container" style="min-height: 0px; max-width: 1000px;">
        <div class="page-title-container" style="padding-top:5rem; padding-bottom: 3rem;">
          <div class="page-title" style="text-align: center;">More releated Twitter threads 👇</div>
        </div>

        <p v-if="related.length === 0">💡 No related threads, check more at the <a @click="$router.push({ path: '/' })">home</a> page.</p>
        
        <div class="masonry-container" style="margin-bottom: 70px;">
          <Tweet 
            v-for="(c, i) in related" 
            :key="`tweet-card-${i}`"

            :id="c.id"
            :likes="c.likes"
            :title="c.title"
            :text="c.tweet.text"
            :createdAt="c.createdAt"
            :is-bot="c.isBot === true"
            :primary-tags="c.primaryTags"
            :secondary-tags="c.secondaryTags"

            :author-id="c.author.id_str"
            :profile-image-url="c.author.profile_image_url_https"
            :location="c.author.location"
            :followers-count="c.author.followers_count"
            :description="c.author.description"
            :screen-name="c.author.screen_name"
            :name="c.author.name"
            :ref="c.ref"
          />
        </div>
      </div>
      
    </div>
  </div>
</template>

<script>
import firebase from '@/firebase'

import Thread from '@/components/Thread.vue'
import Tweet from '@/components/Tweet.vue'

export default {
  components: {
 
    Thread,
    Tweet,
  },

  data() {
    return {
      thread: null,
      related: [],
    }
  },

  mounted() {
    this.start(this.$route.params.id)
  },

  methods: {
    goTwitter(){
      location.href = `https://twitter.com/author/status/${this.$route.params.id}`
    },

    start(id) {
      this.$store.state.showLoading = true
      this.getTweet(id)
      window.scrollTo(0,0)
    },

    async getTweet(id) {
      const snap = await firebase.firestore.collection('threads2').doc(id).get()

      if(snap.exist){
        this.$store.state.showLoading = false
        return
      }

      const thread = snap.data()
      thread.id = snap.id
      thread.ref = snap.ref
      this.thread = thread

      this.$store.state.showLoading = false

      await this.getRelated()
    },

    async getRelated() {
      const snap = await firebase.firestore.collection('threads2')
        .where('primaryTags', 'array-contains-any', this.thread.primaryTags)
        .limit(6)
        .get()

      this.related = snap.docs
        .filter(x => x.id !== this.thread.id)
        .map(x => {
          const m = x.data()
          m.id = x.id
          return m
        })
    }
  },

  beforeRouteUpdate (to, from, next) {
    this.start(to.params.id)
    next()
  },
}
</script>

<style scoped>
h1 {
  text-align: center;
}
.page-container{
  max-width: 1100px;
  min-height: 1100px;
  padding: 0 3rem;
  margin: 0 auto;
}
@media (max-width: 760px){
  .page-container{
    padding: 0 0.5rem;
  }
  .masonry-container{
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    width: 100%;
    align-items: center;
    margin-top: 20px;
  }
}
.masonry-container{
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  justify-content: space-between;
  margin-top: 20px;
}
</style>